import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { Router } from '@angular/router';
import { _ } from 'underscore';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  url = environment.api_url;
  showLogin = true;
  queryObj = {
    hg_accountId: null,
  };

  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = false;
    }
  }
  addClass($event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list-mbl.png';
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close-mbl.svg';
    }
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  gotoProfile() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.hg_accountId) {
        this.router.navigate(['user-settings', result.hg_accountId]);
      } else {
        this.router.navigate(['user-settings', result._id]);
      }
    }
  }

  faqus() {
    sessionStorage.setItem('faqFlag', 'faq');
    sessionStorage.removeItem('contcusFlag');
  }

  fcontactus() {
    sessionStorage.setItem('contcusFlag', 'contact');
    sessionStorage.removeItem('faqFlag');
  }

  getQuestionnaire() {
    //alert("jjjjj");
    if (
      !_.isEmpty(sessionStorage.getItem('userObj')) &&
      _.isEmpty(sessionStorage.getItem('postresult'))
    ) {
      const currentUser = JSON.parse(sessionStorage.getItem('userObj'));
      var hg_accountId = currentUser.hg_accountId
        ? currentUser.hg_accountId
        : currentUser._id;

      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }

      const body = new HttpParams().append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (
              result.user.questionStatusObj != null &&
              result.user.questionStatusObj.questionStatus != 'Completed' &&
              result.userResponses &&
              result.userResponses.length > 0
            ) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  sessionStorage.removeItem('questionStatusObj');
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  console.log(sessionStorage.getItem('userResponse'));
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              this.residentialService.userResponse.userResponses = [];
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }
      this.residentialService.userResponse.userResponses = [];
      if (
        this.residentialService.userResponse.userResponses != null &&
        this.residentialService.userResponse.userResponses.length > 0
      ) {
        sessionStorage.clear();
        this.router.navigateByUrl('/residentialQues');
        this.residentialService.messageService({
          currentId: null,
          questionStatus: null,
        });
        // }
      } else {
        if (!sessionStorage.getItem('Promocode')) {
          sessionStorage.clear();
        }
        this.residentialService.messageService({});
        this.router.navigateByUrl('/residentialQues');
      }
    }
  }
}
